import { ThemeProvider } from '@theme-ui/core'
import { Options as EVCoreDefaultOptions } from '@uswitch/ev-components/lib/components/defaults/options'
import { ConditionalWrapper } from '@uswitch/ev-utils/conditional-wrapper'
import EVCoreProvider from '@uswitch/ev-utils/context/provider'
import React, { useEffect } from 'react'
import { ExperienceProvider } from 'react-chansey'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { Route, Switch } from 'react-router-dom'
import { Provider as UrqlProvider } from 'urql'

import { AppProvider } from '~/contexts/app-context'
import { PageProvider } from '~/contexts/page-context'
import { getTheme } from '~/styles/utils'
import prefix from '~/utils/get-path-prefix'
import { addDestinationFilterForEvents } from '~/utils/tracking'

import ComponentMap from './components/eevee/component-map'
import Routes from './routes'

const App = ({ client, evCore, helmetContext = {}, theme, experiences, ...appProps }) => {
  const routes = Routes()

  useEffect(() => {
    addDestinationFilterForEvents([
      'Experiment Viewed',
      'Experiment Assigned',
      'Form Step Submitted',
      'Form Submitted',
      'Form Loaded',
      'Broadband Form Step Submitted',
      'Broadband Form Submitted',
      'Product List Loaded',
      'Product List Viewed',
      'Product Viewed',
      'Product Clicked',
      'Product Clickout',
      'Promotion Viewed',
      'Promotion Clicked',
      'Element Clicked'
    ])
  }, [])

  return (
    <ThemeProvider theme={getTheme(theme)}>
      <HelmetProvider context={helmetContext}>
        <Helmet />
        <UrqlProvider value={client}>
          <AppProvider value={appProps}>
            <ExperienceProvider value={experiences}>
              <Switch>
                {routes.map(
                  ({
                    component: PageComponent,
                    embeddedEeveeEntityIds = {},
                    path,
                    exact,
                    experiences,
                    ...pageProps
                  }) => {
                    return (
                      <Route
                        key={path}
                        path={`${prefix()}${path}`}
                        exact={exact}
                        render={(props) => (
                          <ConditionalWrapper
                            condition={Object.keys(embeddedEeveeEntityIds).length > 0}
                            wrapper={EVCoreProvider}
                            data={evCore}
                            components={ComponentMap}
                            options={EVCoreDefaultOptions}
                            experiences={experiences}
                          >
                            <PageProvider
                              value={{
                                ...pageProps,
                                ...props,
                                embeddedEeveeEntityIds,
                                experiences
                              }}
                            >
                              <PageComponent {...pageProps} />
                            </PageProvider>
                          </ConditionalWrapper>
                        )}
                      />
                    )
                  }
                )}
              </Switch>
            </ExperienceProvider>
          </AppProvider>
        </UrqlProvider>
      </HelmetProvider>
    </ThemeProvider>
  )
}

export default App
